<template>
    <input type="text" v-model="number" @input="onInput" :placeholder="placeholder" class="L"
    @focus="onFocus"
    />
</template>

<script>

    export default {

        name: "TelephoneInput",

        props : ['country'],

        methods : {
            /**
             * This function handles formatting of telephone number input
             * Sorry for the mess. Feel free to rewrite, if you know what you're doing.
             */
            onInput : function (e) {
                let current = e.target.value;
                let temp = "";
                if(current && !(current.indexOf("+") === 0)) {
                    temp = "+";
                } else {
                    //Try to parse value
                    let parsed = window.parsePhoneNumberFromString(current);
                    if(parsed && parsed.isValid() && parsed.format("INTERNATIONAL") !== this.previous) {
                        temp = parsed.format("INTERNATIONAL");
                    } else {
                        let formatter = new window.phoneFormatter();
                        let formatted = formatter.input(current);

                        let previousNumber = window.parsePhoneNumberFromString(this.previous);
                        if(previousNumber && previousNumber.isValid() &&
                            formatter.nationalNumber.indexOf(previousNumber.nationalNumber) === 0 &&
                                formatter.nationalNumber !== previousNumber.nationalNumber
                        ) {
                            //Propably an extension
                            temp = previousNumber.format("INTERNATIONAL");
                            temp +=    window.getExtPrefix(formatter.country || formatter.metadata._country);
                            temp +=    formatter.nationalNumber.replace(previousNumber.nationalNumber,"");
                        } else if (this.previous &&
                            formatted === this.previous &&
                            current.length < this.previous.length
                        ) {
                            // Detect backspace on formatted number
                            temp = new window.phoneFormatter().input(current.substr(0,current.length-1));
                        } else {
                            temp = formatted;
                        }
                    }
                }
                temp = temp.trim();
                this.number = temp;
                this.previous = temp;

                if(this.$listeners.input) {
                    this.$listeners.input(this.number);
                }
            },

            onFocus(e) {
                let current = e.target.value;                             
                if (current === "" ) this.number = "+" + this.countryCallingCode;
            },

        },

        watch : {
            country() {
                let example = window.getExampleNumber(this.country || "DE");
                if (typeof example === 'object') {
                    return this.placeholder = example.format("INTERNATIONAL");
                } else {
                    return "+49 1512 3456789";
                }
            }
        },

        computed : {
            countryCallingCode () {
                let number = window.getExampleNumber(this.country || "DE");
                if (typeof number === 'object') {
                    return number.countryCallingCode;
                }
                return '';
            }
        },
    

        data () {
            return {
                number : "",
                previous : "",
                placeholder : "+49 1512 3456789"
            }
        }
    }
</script>

<style scoped>

</style>